"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationLayer_1 = require("./AnimationLayer");
var CompositionLayer = (function (_super) {
    tslib_1.__extends(CompositionLayer, _super);
    function CompositionLayer(rawData, version) {
        return _super.call(this, rawData, version) || this;
    }
    Object.defineProperty(CompositionLayer.prototype, "compId", {
        get: function () {
            return this._rawData.refId;
        },
        set: function (imageId) {
            this._rawData.refId = imageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompositionLayer.prototype, "width", {
        get: function () {
            return this._rawData.w;
        },
        set: function (width) {
            this._rawData.w = width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompositionLayer.prototype, "height", {
        get: function () {
            return this._rawData.h;
        },
        set: function (height) {
            this._rawData.h = height;
        },
        enumerable: true,
        configurable: true
    });
    return CompositionLayer;
}(AnimationLayer_1.AnimationLayer));
exports.CompositionLayer = CompositionLayer;
//# sourceMappingURL=CompositionLayer.js.map